export default {
  APP_SET_BOOK_API_URL: 'APP_SET_BOOK_API_URL',
  APP_SET_SHOWROOM_URL: 'APP_SET_SHOWROOM_URL',
  APP_SET_MARKETPLACE_URL: 'APP_SET_MARKETPLACE_URL',
  APP_SET_COMPANY_CODE: 'APP_SET_COMPANY_CODE',
  APP_SET_S3_BUCKET: 'APP_SET_S3_BUCKET',

  APP_RESET: 'APP_RESET',
};
